import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ConditionSchema = withDefaults({
  type: 'condition',
  objectExtensions: ['condition'],
  fields: [
    {
      kind: 'attribute',
      name: 'classification',
    },
    {
      kind: 'attribute',
      name: 'province',
    },
    {
      kind: 'attribute',
      name: 'expiryCadence',
    },
    {
      kind: 'attribute',
      name: 'expiryFixedDate',
    },
    {
      kind: 'attribute',
      name: 'filename',
    },
    {
      kind: 'attribute',
      name: 'fullText',
    },
    {
      kind: 'attribute',
      name: 'prompt',
    },
    {
      kind: 'attribute',
      name: 'isDefault',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'hasMany',
      name: 'agreements',
      type: 'agreement',
      options: {
        async: false,
        inverse: 'condition',
      },
    },
    {
      kind: 'belongsTo',
      name: 'conditionable',
      type: 'conditionable',
      options: {
        async: false,
        polymorphic: true,
        inverse: 'conditions',
      },
    },
    {
      kind: 'hasMany',
      name: 'publicAssets',
      type: 'public-asset',
      options: {
        async: false,
        inverse: 'conditions',
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default ConditionSchema;
